export default [
    // Lightbulb model
    {
        name: 'lightbulb',
        type: 'gltfModel',
        path: 'models/Lightbulb/lightbulb.glb'
    },
    // Wood
    {
        name: 'woodColorTexture',
        type: 'texture',
        path: 'textures/wood/dark_wood_diff_1k.webp'
    },
    {
        name: 'woodNormalTexture',
        type: 'texture',
        path: 'textures/wood/dark_wood_nor_gl_1k.webp'
    },
    {
        name: 'woodARMTexture',
        type: 'texture',
        path: 'textures/wood/dark_wood_arm_1k.webp'
    },
    {
        name: 'woodDisplacementTexture',
        type: 'texture',
        path: 'textures/wood/dark_wood_disp_1k.webp'
    }
]